export default __webpack_public_path__ + "static/media/Essex_Icons_Location 1.ecd3b5db.svg";